/*
 * Disables the random screen-glitch effect from the original design:
 * SATComponent.prototype.startGlitchWatcher() runs a loop that, every
 * 30-60 seconds, has a 22% chance of flashing to a random terminal/record
 * view (80s terminal, a 90s record, or the Restricted/Classified view) for
 * ~140-240ms before reverting to the storefront. Confirmed intentional in
 * the original build, not a bug — removed here at the merchant's request.
 *
 * The first version of this patch (overriding startGlitchWatcher itself to
 * a no-op) never actually worked. sat-app.js's own boot IIFE calls
 * SAT.mount() -> componentDidMount() -> startGlitchWatcher() synchronously,
 * during sat-app.js's own <script defer> execution — before the browser
 * even starts loading THIS patch's script tag, since deferred scripts run
 * strictly in source order and sat-app.js is first in that order. By the
 * time this file's override reached the prototype, the original method had
 * already been called once and its async while-loop was already running;
 * reassigning the prototype afterward does nothing to a function invocation
 * already in flight. The flash reappearing after a while (rather than never
 * actually having stopped) is exactly what that timing bug looks like.
 *
 * Fixed at the right level instead: the loop's body calls this.setState(...)
 * fresh on every surviving iteration — a dynamic lookup on `this`, not a
 * reference captured once — so a patch that loads after boot still
 * intercepts every future call the already-running loop makes. The loop
 * can't fire its first check sooner than 30s after page load (its own first
 * await), which is all the head start this script — loading within
 * milliseconds — needs. Detects the three exact flash payloads (each a
 * 2-key object with no `returnTo`) and drops just those; every real
 * navigation path to the same terminals either goes through a boot sequence
 * first (setting the view alone, afterward) or includes a `returnTo` key,
 * so genuine deep links and nav clicks are unaffected.
 */
(function () {
  'use strict';
  if (!window.SATComponent) { return; }

  function isGlitchFlash(update) {
    if (!update || typeof update !== 'object') return false;
    var v = update.view;
    if (v !== 'term80' && v !== 'view90' && v !== 'viewrd') return false;
    if (Object.keys(update).length !== 2) return false;
    if (v === 'term80') return update.activeRecord === 'lbe';
    if (v === 'view90') return update.active90 === 'rig';
    return update.activeRd === 'x000'; // v === 'viewrd'
  }

  var origSetState = window.SATComponent.prototype.setState;
  if (typeof origSetState !== 'function') { return; } // defensive: nothing to wrap
  window.SATComponent.prototype.setState = function (update, cb) {
    // Silently drop the flash itself. The revert call a moment later
    // (the loop's own `this.setState({view:'site'})`) just re-sets the
    // view onto its current value — harmless, left alone.
    if (isGlitchFlash(update)) { return; }
    return origSetState.call(this, update, cb);
  };
})();
